'use client';

import { Select, type SelectOption } from '@/app/_components/core/select';
import type { EventFilters } from '@/app/_components/shared/event-bento/event-bento.types';
import { useLabel } from '@/app/_contexts/labels-context';

const ALL_VALUE = '__all__';

interface EventBentoFiltersProps {
  filters: EventFilters;
  selectedLocation: string;
  selectedCategory: string;
  onLocationChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
}

const buildOptions = (allLabel: string, values: string[]): SelectOption[] => [
  { label: allLabel, value: ALL_VALUE },
  ...values.map((v) => ({ label: v, value: v })),
];

function EventBentoFilters({
  filters,
  selectedLocation,
  selectedCategory,
  onLocationChange,
  onCategoryChange,
}: EventBentoFiltersProps) {
  const locationLabel = useLabel('location', 'Location');
  const allLocationsLabel = useLabel('allLocations', 'Alle Standorte');
  const categoryLabel = useLabel('category', 'Kategorie');
  const allCategoriesLabel = useLabel('allCategories', 'Alle Kategorien');

  const locations = filters.location ?? [];
  const categories = filters.categories ?? [];

  if (!locations.length && !categories.length) return null;

  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:gap-4">
      {locations.length > 0 && (
        <Select
          value={selectedLocation}
          onValueChange={onLocationChange}
          placeholder={locationLabel}
          aria-label={locationLabel}
          options={buildOptions(allLocationsLabel, locations)}
          fullWidth={false}
          className="w-full sm:w-auto sm:min-w-50"
        />
      )}
      {categories.length > 0 && (
        <Select
          value={selectedCategory}
          onValueChange={onCategoryChange}
          placeholder={categoryLabel}
          aria-label={categoryLabel}
          options={buildOptions(allCategoriesLabel, categories)}
          fullWidth={false}
          className="w-full sm:w-auto sm:min-w-50"
        />
      )}
    </div>
  );
}

export { EventBentoFilters, ALL_VALUE };
